import React, { useEffect, useState } from 'react';
import VideoPlayer from './VideoPlayer';
import { useLocation } from 'react-router-dom';

const BEARER_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYWRtaW4iLCJzZXNzaW9uSWQiOiJlZjk3ZWNjMS03OGU1LTQ4MGItYWNhYS1kMmRkZjY0NDQ4YWYiLCJzdWIiOjEsImVtYWlsIjoiYWRtaW4gYWRtaW4gYWRtaW4iLCJvcmdhbmlzYXRpb25JZCI6MSwiaWF0IjoxNzUwMTY0NjIzLCJleHAiOjIwNjU1MjQ2MjN9.m7AW1hfO7jfdK1jNGhEgKC4CsRY1kgfXG2c1_dUSeQg';

const App: React.FC = () => {
  const location = useLocation();
  const [visitData, setVisitData] = useState<any>(null);
  const [loading, setLoading] = useState(false);


  // Парсим path: /3/doidrandom
  const pathParts = location.pathname.split('/').filter(Boolean);
  const visitId = pathParts[0];
  const doctorId = pathParts[1];
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  window.addEventListener("orientationchange", function() {

    setTimeout(function() {
        const isLandscape = window.innerWidth > window.innerHeight;
        console.log(isLandscape)
        if (isLandscape && isSafari) {
            window.scrollTo(0, 100);
            // @ts-ignore
            document.getElementById('videoplayer').style.height = window.screen.width - 25 + 'px'
        } else {
            window.scrollTo(0, 0);
            document.body.classList.remove('disable-scroll');
            // @ts-ignore
            document.getElementById('videoplayer').style.height = '100vh'
        }

    }, 300);
  });

    useEffect(() => {
        setVisitData({
            "id": 18,
            "title": "SmartTensin Demo",
            "description": "",
            "picture": {
                "id": 1,
                "fileName": "120x120.svg",
                "raw": "/app/uploads/6c840d125afbf515eebf8b38d9e05a79"
            },
            "slides": [
                {
                    "id": 779,
                    "title": "slide08",
                    "description": "",
                    "fileName": "slide08.html",
                    "presentation": {
                        "id": 15,
                        "title": "SmartTensin 08",
                        "description": "",
                        "status": "ACTIVE",
                        "slidesRoot": "/app/uploads/presentations/15/slides-root",
                        "createdAt": "2025-08-05T21:02:05.809Z"
                    },
                    "statisticRecordIsAllow": true,
                    "durationMs": 10000,
                    "picture": {
                        "id": 1132,
                        "fileName": "slide08.png",
                        "raw": "/app/uploads/presentations/15/slides/slide08_screenshots/1754514542869.png"
                    },
                    "status": "ACTIVE",
                    "createdAt": "2025-08-05T21:02:49.138Z"
                },
                {
                    "id": 777,
                    "title": "slide03",
                    "description": "",
                    "fileName": "slide03.html",
                    "presentation": {
                        "id": 14,
                        "title": "SmartTensin 03",
                        "description": "",
                        "status": "ACTIVE",
                        "slidesRoot": "/app/uploads/presentations/14/slides-root",
                        "createdAt": "2025-08-05T18:55:16.310Z"
                    },
                    "statisticRecordIsAllow": true,
                    "durationMs": 23000,
                    "picture": {
                        "id": 1117,
                        "fileName": "slide03.png",
                        "raw": "/app/uploads/presentations/14/slides/slide03_screenshots/1754513184788.png"
                    },
                    "status": "ACTIVE",
                    "createdAt": "2025-08-05T18:56:04.513Z"
                },
                {
                    "id": 793,
                    "title": "slide042",
                    "description": "",
                    "fileName": "slide042.html",
                    "presentation": {
                        "id": 16,
                        "title": "SmartTensin 04",
                        "description": "",
                        "status": "ACTIVE",
                        "slidesRoot": "/app/uploads/presentations/16/slides-root",
                        "createdAt": "2025-08-05T21:10:03.599Z"
                    },
                    "statisticRecordIsAllow": true,
                    "durationMs": 10000,
                    "picture": {
                        "id": 1114,
                        "fileName": "slide042.png",
                        "raw": "/app/uploads/presentations/16/slides/slide042_screenshots/1754512743483.png"
                    },
                    "status": "ACTIVE",
                    "createdAt": "2025-08-05T21:29:28.443Z"
                },
                {
                    "id": 760,
                    "title": "slide06",
                    "description": "",
                    "fileName": "slide06.html",
                    "presentation": {
                        "id": 13,
                        "title": "SmartTensin",
                        "description": "",
                        "status": "ACTIVE",
                        "slidesRoot": "/app/uploads/presentations/13/slides-root",
                        "createdAt": "2025-08-05T18:39:36.672Z"
                    },
                    "statisticRecordIsAllow": true,
                    "durationMs": 10000,
                    "picture": {
                        "id": 1123,
                        "fileName": "slide06.png",
                        "raw": "/app/uploads/presentations/13/slides/slide06_screenshots/1754513387224.png"
                    },
                    "status": "ACTIVE",
                    "createdAt": "2025-08-05T18:40:44.313Z"
                },
                {
                    "id": 761,
                    "title": "slide07",
                    "description": "",
                    "fileName": "slide07.html",
                    "presentation": {
                        "id": 13,
                        "title": "SmartTensin",
                        "description": "",
                        "status": "ACTIVE",
                        "slidesRoot": "/app/uploads/presentations/13/slides-root",
                        "createdAt": "2025-08-05T18:39:36.672Z"
                    },
                    "statisticRecordIsAllow": true,
                    "durationMs": 10000,
                    "picture": {
                        "id": 1124,
                        "fileName": "slide07.png",
                        "raw": "/app/uploads/presentations/13/slides/slide07_screenshots/1754513402933.png"
                    },
                    "status": "ACTIVE",
                    "createdAt": "2025-08-05T18:40:48.451Z"
                },
                {
                    "id": 763,
                    "title": "slide09",
                    "description": "",
                    "fileName": "slide09.html",
                    "presentation": {
                        "id": 13,
                        "title": "SmartTensin",
                        "description": "",
                        "status": "ACTIVE",
                        "slidesRoot": "/app/uploads/presentations/13/slides-root",
                        "createdAt": "2025-08-05T18:39:36.672Z"
                    },
                    "statisticRecordIsAllow": true,
                    "durationMs": 10000,
                    "picture": {
                        "id": 1126,
                        "fileName": "slide09.png",
                        "raw": "/app/uploads/presentations/13/slides/slide09_screenshots/1754513441263.png"
                    },
                    "status": "ACTIVE",
                    "createdAt": "2025-08-05T18:40:56.601Z"
                },
                {
                    "id": 764,
                    "title": "slide10",
                    "description": "",
                    "fileName": "slide10.html",
                    "presentation": {
                        "id": 13,
                        "title": "SmartTensin",
                        "description": "",
                        "status": "ACTIVE",
                        "slidesRoot": "/app/uploads/presentations/13/slides-root",
                        "createdAt": "2025-08-05T18:39:36.672Z"
                    },
                    "statisticRecordIsAllow": true,
                    "durationMs": 10000,
                    "picture": {
                        "id": 1127,
                        "fileName": "slide10.png",
                        "raw": "/app/uploads/presentations/13/slides/slide10_screenshots/1754513456406.png"
                    },
                    "status": "ACTIVE",
                    "createdAt": "2025-08-05T18:41:01.355Z"
                }
            ],
            "video": {
                "raw": "/app/uploads/visites/18/video.mp4",
                "hls": null,
                "status": "DONE"
            },
            "createdAt": "2025-08-05T19:00:54.272Z"
        })
        // Запретить скролл пользователю
        document.body.classList.add('disable-scroll');
        const disableTouchScroll = (e: { preventDefault: () => void; stopPropagation: () => void; }) => { e.preventDefault(); e.stopPropagation(); };
        document.body.addEventListener('touchmove', disableTouchScroll, { passive: false });

        // Очистка
        return () => {
            document.body.classList.remove('disable-scroll');
            document.body.removeEventListener('touchmove', disableTouchScroll);
        };
    }, []);

    // Программная прокрутка по кнопке
    // const scrollDown = () => window.scrollTo({ top: 500, behavior: 'smooth' });

  // useEffect(() => {
  //   if (!visitId) return;
  //   fetch(`https://stage.selfdetailing.ru/api/visit/${visitId}`, {
  //     method: 'GET',
  //     headers: {
  //       'Accept': 'application/json',
  //     },
  //   })
  //       .then(res => res.json())
  //       .then(data => {
  //         setVisitData(data);
  //         setLoading(false);
  //       })
  //       .catch(() => setLoading(false));
  // }, [visitId]);

  if (loading) return <div>Загрузка...</div>;
  if (!visitData) return <div>Ошибка загрузки визита</div>;

  return (
      <>
        <div id='hideafterscroll' style={{height: 'calc(100vh + 200px)'}}></div>
        <VideoPlayer
            videoUrl={'https://2023mc1.likeforce.ru/sd.mp4'}
            slides={visitData.slides}
            visit={visitData}
            doctorId={doctorId}
        />
      </>

  );
};

export default App;
